module.exports = __webpack_public_path__ + "images/search44d9437b2cb84f88d49abd64026dcfda.svg";